<template>
    <div>

        <div class="col1">
            <Singlemessagethread  />
        </div>
         <div id="bottom"></div>
        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser} from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Singlemessagethread from './Singlemessagethread'
    export default {
        components: {
            Singlemessagethread
            },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        mounted(){
            //let elmnt = document.getElementById('bottom');
            //elmnt.scrollIntoView(true);

            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        }

        
    }
</script>